import React from "react";
import Lottie from "react-lottie";
import { hiOptions, starOptions } from "./animations"; // Importer animasjoner
import { useStarPositions } from "./useStarPositions"; // Importer custom hook for stjerner
import "./home.css";
import HeaderSocials from "./HeaderSocials";
import ScrollDown from "./ScrollDown";

const Home = () => {
  const { visibleStars, starPositions } = useStarPositions(); 

  return (
    <section className="home container" id="home">
      <div className="intro">
        <Lottie options={hiOptions} height={200} width={400} />
        <h1 className="home__name">My name is Selma</h1>
        <span className="home__education">I'm a master student at UiB with a bachelors degree from HVL </span>

        <HeaderSocials />
        <a href="#contact" className="btn">Contact Me</a>
        <ScrollDown />

        <div className="stars">
          {/* Stjerner på større skjerm */}
          {window.innerWidth > 768 && visibleStars[0] && (
            <>
              <Lottie options={starOptions[0]} height={50} width={50} style={{ position: 'absolute', ...starPositions[0] }} />
              <Lottie options={starOptions[0]} height={50} width={50} style={{ position: 'absolute', ...starPositions[1] }} />
              <Lottie options={starOptions[0]} height={50} width={50} style={{ position: 'absolute', ...starPositions[2] }} />
            </>
          )}
          {window.innerWidth > 768 && visibleStars[1] && (
            <>
              <Lottie options={starOptions[1]} height={50} width={50} style={{ position: 'absolute', ...starPositions[3] }} />
              <Lottie options={starOptions[1]} height={50} width={50} style={{ position: 'absolute', ...starPositions[4] }} />
              <Lottie options={starOptions[1]} height={50} width={50} style={{ position: 'absolute', ...starPositions[5] }} />
            </>
          )}
          {window.innerWidth > 768 && visibleStars[2] && (
            <>
              <Lottie options={starOptions[2]} height={50} width={50} style={{ position: 'absolute', ...starPositions[6] }} />
              <Lottie options={starOptions[2]} height={50} width={50} style={{ position: 'absolute', ...starPositions[7] }} />
              <Lottie options={starOptions[2]} height={50} width={50} style={{ position: 'absolute', ...starPositions[8] }} />
            </>
          )}
          {window.innerWidth > 768 && visibleStars[3] && (
            <>
              <Lottie options={starOptions[3]} height={50} width={50} style={{ position: 'absolute', ...starPositions[9] }} />
              <Lottie options={starOptions[3]} height={50} width={50} style={{ position: 'absolute', ...starPositions[10] }} />
              <Lottie options={starOptions[3]} height={50} width={50} style={{ position: 'absolute', ...starPositions[11] }} />
            </>
          )}
          {window.innerWidth > 768 && visibleStars[4] && (
            <>
              <Lottie options={starOptions[4]} height={50} width={50} style={{ position: 'absolute', ...starPositions[12] }} />
              <Lottie options={starOptions[4]} height={50} width={50} style={{ position: 'absolute', ...starPositions[13] }} />
              <Lottie options={starOptions[4]} height={50} width={50} style={{ position: 'absolute', ...starPositions[14] }} />
            </>
          )}

          {/* Stjerner på mindre skjerm (5 stjerner) */}
          {window.innerWidth <= 768 && visibleStars.map((visible, index) => (
            visible && (
              <Lottie
                key={index}
                options={starOptions[index]}
                height={50}
                width={50}
                style={{ position: 'absolute', ...starPositions[index] }}
              />
            )
          ))}
        </div>
      </div>
    </section>
  );
};

export default Home;
